import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
// import { Link } from 'react-router';
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import faBan from "@fortawesome/fontawesome-pro-solid/faBan";
import { ModalActions } from '../../actions/modal';
import { ProjectActions } from '../../actions/project';


// import faLockAlt from '@fortawesome/fontawesome-pro-solid/faLockAlt';

export default class SuspendedCard extends React.Component {
  static propTypes = {
    project: PropTypes.instanceOf(Map).isRequired
  };

  deleteProject = () => {
    const { dispatch, project } = this.props;
    const projectId = project.get('id');
    dispatch(ProjectActions.deleteProject(projectId));
  };

  confirmDelete = () => {
    const { dispatch, project } = this.props;
    const name = project.get('name');

    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'project',
        handleDelete: this.deleteProject.bind(this),
        name,
      },
    }));
  }

  render() {
    const { project, unsuspendProject, superAdmin, isAccountAdmin } = this.props;
    const unsuspendButton = !superAdmin ? null : (
      <div className="row justify-content-center mt-3">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={() => {
            unsuspendProject(project.get("id"));
          }}
        >
          Remove Suspension
        </button>
      </div>
    );

    const deleteButton = isAccountAdmin || superAdmin ? (
      <div className="row justify-content-center mt-2">
        <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={() => {
            this.confirmDelete(project.get("id"));
          }}
        >
          Delete Project
        </button>
      </div>
    ) : null;

    return (
      <div
        className="card project-card p-3"
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          fontFamily: "Arial",
          color: "#9a9a9add"
        }}
      >
        <div className="row justify-content-center mb-1">
          <FontAwesomeIcon size="3x" icon={faBan} />
        </div>
        <div className="row justify-content-center mb-1">
          <p>
            <em style={{ fontWeight: 700 }}>{project.get("name")}</em> is
            currently suspended.
          </p>
        </div>
        <div className="dropdown-divider" />
        <div className="row justify-content-center mb-1">
          <small>
            For assistance, please contact your organization's Sight administrator.
          </small>
        </div>
        {unsuspendButton}
        {deleteButton}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/SuspendedCard.js